module.exports = __webpack_public_path__ + "static/img/132a8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/openAccount/images/success.png
// module id = 668
// module chunks = 2